import React from 'react';
import { Link } from 'react-router-dom'
import blogs from '../../api/blogs'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BlogSidebar = (props) => {
    return (
        <div className="blog-sidebar">
            <div className="widget search-widget">
                <h3>Search here</h3>
                <form>
                    <div>
                        <input type="text" className="form-control" placeholder="Search Post.." />
                        <button type="submit"><i className="ti-search"></i></button>
                    </div>
                </form>
            </div>
            <div className="widget category-widget">
                <h3>Categories</h3>
                <ul>
                    <li><Link onClick={ClickHandler} to="/blog">Architecture<span>03</span></Link></li>
                    <li><Link onClick={ClickHandler} to="/blog" className="active">Construction
                        <span>02</span></Link></li>
                    <li><Link onClick={ClickHandler} to="/blog">Innovation  <span>04</span></Link></li>
                    <li><Link onClick={ClickHandler} to="/blog">Development <span>05</span></Link></li>
                    <li><Link onClick={ClickHandler} to="/blog">Interior <span>05</span></Link></li>
                    <li><Link onClick={ClickHandler} to="/blog">Furniture <span>05</span></Link></li>
                </ul>
            </div>
            <div className="widget recent-post-widget">
                <h3>Related Posts</h3>
                <div className="posts">
                    {blogs.slice(0, 3).map((blog, bl) => (
                        <div className="post" key={bl}>
                            <div className="img-holder">
                                <img src={blog.screens} alt="" />
                            </div>
                            <div className="details">
                                <h4><Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>{blog.title2}</Link></h4>
                                <span className="date">{blog.create_at}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="widget tag-widget">
                <h3>Populer Tags</h3>
                <ul>
                    <li><Link onClick={ClickHandler} to="#">Architecture</Link></li>
                    <li><Link onClick={ClickHandler} to="#">Construction</Link></li>
                    <li><Link onClick={ClickHandler} to="#">Interior</Link></li>
                    <li><Link onClick={ClickHandler} to="#">Urban</Link></li>
                    <li><Link onClick={ClickHandler} to="#">Building</Link></li>
                    <li><Link onClick={ClickHandler} to="#">Development</Link></li>
                    <li><Link onClick={ClickHandler} to="#">Furniture</Link></li>
                    <li><Link onClick={ClickHandler} to="#">Space</Link></li>
                    <li><Link onClick={ClickHandler} to="#">Room</Link></li>
                    <li><Link onClick={ClickHandler} to="#">Chair</Link></li>
                </ul>
            </div>
        </div>
    )

}

export default BlogSidebar;



